import { render, staticRenderFns } from "./OrganisationsBlock.vue?vue&type=template&id=cb7287d2&scoped=true"
import script from "./OrganisationsBlock.vue?vue&type=script&lang=ts"
export * from "./OrganisationsBlock.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationsBlock.vue?vue&type=style&index=0&id=cb7287d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7287d2",
  null
  
)

export default component.exports